import React, { PureComponent, useState } from "react";
import usePermission from "../hooks/usePermission";
import { Box, Switch, FormControlLabel } from "@mui/material";
import { DataGrid, GridToolbar, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarExport, GridToolbarExportContainer, getGridStringOperators, GridToolbarQuickFilter } from "@mui/x-data-grid";

import {
  MenuItem
} from "@mui/material";

export default function CustomGridToolbar(props) {
  const { apiRef,
    queryOptions,
    paginationModel,
    isDownload,
    setIsDownload,
    apiUrl,
    module,
    region,
    state,
    startDate,
    endDate,
    reward_id,
    teaching_category,
    gender,
    showMaskingSwitch = false, // New prop for conditional rendering
    maskingSwitchState, // New prop for controlling the switch state
    setMaskingSwitchState, // New prop for updating the switch state
    download_csv, //individual content download
    module_type, //individual content downloads
    hasfilter = true,
    hasSearch = true,
    hasExport = true,
    course_id,
    analytics_type,
    additionalQueryParams = {},
    // RBAC: pass the module name to guard export (e.g. "pbl", "courses").
    // If omitted, export is always allowed (backward compat).
    permissionModule = null,
  } = props;

  const { requirePermission } = usePermission();

  const _doApiCall = async () => {
    try {
      const filterModel = queryOptions?.filterModel;
      const sortModel = queryOptions?.sortModel;
      const items = filterModel?.items;
      const firstItem = items && items.length > 0 ? items[0] : {};
      const quickFilterValues = filterModel?.quickFilterValues;
      let query
      if (sortModel?.length > 0) {
        query = {
          analytics_type: `${analytics_type}`,
          page: paginationModel?.page + 1,
          page_size: paginationModel?.pageSize,
          sort_order: sortModel[0].sort || "desc",
          module_name: module || '',
          city: region || '',
          state: state || '',
          reward_id: reward_id || '',
          gender: gender || '',
          startDate: startDate || '',
          teaching_category: teaching_category,
          endDate: endDate || '',
          field: firstItem.field || (gender ? "gender" : '') || '',
          operator: firstItem.operator || (quickFilterValues && "contains") || '',
          value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || gender || '',
          masking: maskingSwitchState, // Include masking in the query
          download_csv, //individual content download
          module_type, //individual content downloads
          course_id,
          ...additionalQueryParams,
        };
      } else {
        query = {
          analytics_type: `${analytics_type}`,
          page: paginationModel?.page + 1,
          page_size: paginationModel?.pageSize,
          sort_order: "desc",
          module_name: module || '',
          city: region || '',
          state: state || '',
          reward_id: reward_id || '',
          gender: gender || '',
          startDate: startDate || '',
          teaching_category: teaching_category,
          endDate: endDate || '',
          field: firstItem.field || (gender ? "gender" : '') || '',
          operator: firstItem.operator || (quickFilterValues && "contains") || '',
          value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || gender || '',
          masking: maskingSwitchState, // Include masking in the query
          download_csv, //individual content download
          module_type, //individual content downloads
          course_id,
          ...additionalQueryParams,
        };
      }
      const obj = {
        csv: true,
        file_type: "csv",
        sort_order: "desc",
        ...query
      };

      // Filter out empty or unnecessary values to prevent sending them in the API request
      const cleanObj = Object.fromEntries(
        Object.entries(obj).filter(([_, v]) =>
          v !== '' && v !== undefined && v !== null && !Number.isNaN(v) && v !== 'undefined'
        )
      );

      const queryParameters = new URLSearchParams(cleanObj);
      const queryString = queryParameters.toString();
      const apiUrlWithParams = `${process.env.REACT_APP_BASE_URL}${apiUrl}?${queryString}`;
      setIsDownload(true)
      const response = await fetch(apiUrlWithParams, {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        setIsDownload(false)
        throw new Error('Network response was not ok');
      }
      var fileName
      let contentDisposition = response.headers.get('Content-Disposition')
      if (contentDisposition) {
        // Use regex to capture the filename
        const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);

        if (fileNameMatch && fileNameMatch[1]) {
          fileName = fileNameMatch[1];
          console.log("Filename:", fileName);
        } else {
          console.log("Filename not found in Content-Disposition header.");
        }
      } else {
        console.log("Content-Disposition header not present.");
      }
      const blob = await response.blob();

      // Create a URL for the file
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      if (fileName && fileName !== '') {
        link.setAttribute('download', `${fileName}`)
      } else {
        link.setAttribute('download', `${props?.moduleType}_report_${new Date().getTime()}.csv`); // Specify the file name
      }
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setIsDownload(false)
    } catch (error) {
      console.error('Error exporting data:', error);
      setIsDownload(false)
      alert('Failed to export data.');
    }
  };

  // Wrap with RBAC guard. If permissionModule is null, export always proceeds.
  const handleApiCall = requirePermission(permissionModule, 'export', _doApiCall);
  function CustomExportButton({ }) {

    return (
      <MenuItem onClick={handleApiCall}>
        Export to CSV
      </MenuItem>
    );
  }
  function CustomToolbarExport(props) {
    const { apiRef } = props;

    return (
      <GridToolbarExportContainer>
        <CustomExportButton apiRef={apiRef} />
      </GridToolbarExportContainer>
    );
  }
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      {hasfilter &&
        <GridToolbarFilterButton />
      }
      <GridToolbarDensitySelector
        slotProps={{
          loadingOverlay: {
            variant: 'linear-progress',
            noRowsVariant: 'linear-progress',
          }, tooltip: { title: 'Change density' }
        }}
      />
      {hasExport && <CustomToolbarExport apiRef={apiRef} />}
      {showMaskingSwitch && ( // Conditionally render the switch
        <FormControlLabel
          control={
            <Switch
              checked={maskingSwitchState}
              onChange={(e) => setMaskingSwitchState(e.target.checked)}
              name="maskingSwitch"

            />
          }
          label="Enable Masking"
          labelPlacement="start"
        />
      )}
      <Box sx={{ flexGrow: 1 }} />
      {hasSearch &&
        <GridToolbarQuickFilter debounceMs={1500} />
      }
    </GridToolbarContainer>
  );
}
